var _path, _circle, _path2, _circle2, _path3, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    fill: "none",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M29.4468 20.3703C30.4074 18.7097 32.2028 17.5925 34.2591 17.5925H43.0991C46.3263 17.5925 48.8744 20.3329 48.64 23.5515L47.2221 43.0259H35.2244L36.477 27.3687C36.7787 23.5973 33.7996 20.3703 30.0162 20.3703H29.4468Z",
    clipRule: "evenodd"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 38.889,
    cy: 8.333,
    r: 5.556,
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M1.35969 23.5515C1.12534 20.3329 3.67342 17.5925 6.90058 17.5925H15.7406C17.797 17.5925 19.5924 18.7097 20.5529 20.3703H19.9836C16.2002 20.3703 13.221 23.5973 13.5227 27.3687L14.7753 43.0259H2.77766L1.35969 23.5515Z",
    clipRule: "evenodd"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.111,
    cy: 8.333,
    r: 5.556,
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M20.8077 22.2222C17.5738 22.2222 15.0233 24.9736 15.2681 28.1982L16.6663 46.6177H33.333L34.7312 28.1982C34.976 24.9736 32.4255 22.2222 29.1916 22.2222H20.8077Z",
    opacity: 0.6
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 12.963,
    r: 5.556,
    fill: "#fff",
    opacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeam);
export default __webpack_public_path__ + "static/media/team.8d99ace5793c474424b10195be8a8d31.svg";
export { ForwardRef as ReactComponent };